var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"100%","text-align":"left"}},[_c('v-icon',[_vm._v(" mdi-earth ")]),_vm._v(" "+_vm._s(_vm.item[_vm.language].label)+" ")],1),_c('hr'),_c('v-btn',{staticStyle:{"margin":"50px"},attrs:{"link":"","href":_vm.item[_vm.language].value.link.url,"target":"_blank"}},[_vm._v("Open")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }